import {LangKeyType} from '../../../../../../../provider/locale/translation/type';

export const cclOnboardingTranslationMap: Record<string, LangKeyType> = {
    time: 'SOURCES__ONBOARDING__POPOVER__STATUS_DATA__NAME',
    address: 'SOURCES__ONBOARDING__POPOVER__STATUS_DATA__ADDRESS',
    phone: 'SOURCES__ONBOARDING__POPOVER__STATUS_DATA__PHONE',
    workingHours: 'SOURCES__ONBOARDING__POPOVER__STATUS_DATA__WORKING_HOURS',
    openStatus: 'SOURCES__ONBOARDING__POPOVER__STATUS_DATA__OPEN',
};
